import { CloseOutlined } from "@ant-design/icons";

const AddModalHeader = ({ modalTitle, toggleModal }) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <h1
      style={{
        height: "100%",
        backgroundColor: "lightgray",
        fontSize: "20px",
        padding: "1.5%",
        width: "90%",
      }}
    >
      {modalTitle}
    </h1>
    <button
      onClick={toggleModal}
      style={{
        backgroundColor: "lightgray",
        width: "54px",
        height: "39px",
        marginLeft: "-2px",
      }}
    >
      <CloseOutlined style={{ fontSize: 20, color: "black" }} />
    </button>
  </div>
);
export default AddModalHeader;
